import LandingPage from './LandingPage';
import BookingPage from './BookingPage';

// Two pages, no router library — flyafritrip.com/booking is served the
// same index.html as everything else (see the Caddy `try_files` rule in
// ~/Desktop/flyafritrip-middleware/Caddyfile), so branching on the path is
// enough and avoids adding react-router-dom for a two-page site.
export default function App() {
  const isBookingPage = window.location.pathname.replace(/\/+$/, '').endsWith('/booking');
  return isBookingPage ? <BookingPage /> : <LandingPage />;
}
